import type { ReactNode } from 'react';
import React, { createContext, useState, useCallback } from 'react';
import { LoadingModal } from './LodingModal';
import type { ModalState } from './LodingModal';

interface SpinnerContextType {
  startSpin: (message?: string) => void;
  endSpin: () => void;
  showSuccess: (message?: string) => void;
  showError: (message?: string) => void;
}

export const SpinnerContext = createContext<SpinnerContextType | null>(null);

interface SpinnerProviderProps {
  children: ReactNode;
}

export const SpinnerProvider: React.FC<SpinnerProviderProps> = ({ children }) => {
  const [modalState, setModalState] = useState<ModalState>({
    isVisible: false,
    message: '',
    type: 'loading',
  });

  const startSpin = useCallback((message: string = '처리 중...') => {
    setModalState({
      isVisible: true,
      message,
      type: 'loading',
    });
  }, []);

  const endSpin = useCallback(() => {
    setModalState({
      isVisible: false,
      message: '',
      type: 'loading',
    });
  }, []);

  const showSuccess = useCallback((message: string = '처리 완료!') => {
    setModalState({
      isVisible: true,
      message,
      type: 'success',
    });
  }, []);

  const showError = useCallback((message: string = '처리 실패') => {
    setModalState({
      isVisible: true,
      message,
      type: 'error',
    });
  }, []);

  return (
    <SpinnerContext.Provider value={{ startSpin, endSpin, showSuccess, showError }}>
      {children}
      <LoadingModal isVisible={modalState.isVisible} message={modalState.message} type={modalState.type} />
    </SpinnerContext.Provider>
  );
};
